import React, { useCallback } from "react";

const Button = ({
  name,
  background = "#FFD666",
  width,
  height = "48px",
  classNames,
  divStyle,
  onClickHandler,
  disabled,
}) => {
  const getClasses = useCallback(() => {
    let classes = `bg-[${background}] shadow-[0px_0px_1px_rgba(20, 20, 20, 0.08), 0px_1px_8px_2px_rgba(20, 20, 20, 0.08)] rounded-3xl font-font-Titillium font-semibold text-[18px] text-[#141414] text-center leading-[27px] tracking-[0.0781em]`;
    if (width) {
      classes += ` w-[${width}]`;
    }
    if (height) {
      classes += ` h-[${height}]`;
    }
    if (classNames) {
      classes += " " + classNames;
    }
    return classes;
  }, [background, classNames, height, width]);
  return (
    <div className={`flex items-center ${divStyle}`}>
      <button
        className={getClasses()}
        onClick={onClickHandler}
        disabled={disabled}
      >
        {name}
      </button>
    </div>
  );
};

export default Button;
